module.exports = __webpack_public_path__ + "static/media/clinician.fb0b7e44.svg";